import React from "react";
import PropTypes from "prop-types";
import * as COMMON from "../components/Common";
import * as CONFIG from "./configState";

import {
    bondorBrickworkWarning,
    createConditionFunction,
    getMaxPostHeight,
    getPos,
    insulatedSpanWarning,
    interpolate,
    postFootingWarning,
    postHeightWarning,
    postNotchedWarning,
} from "./warningHelper";
import { SHOW_DESIGNER_MESSAGE, validateFullJob } from "./jobState_Validation";
import { brickworkBondorHeightCondition } from "../components_designer/DesignerDrawingWarnings";
import { BASIC_SPECS_SECTIONS } from "./jobState_Schemas";

// Callback function
function allAreaSpecifications(job, callback) {
    for (let index in job.AreaSpecifications) {
        let areaIndex = Number(index);
        const this_area = job.AreaSpecifications[Number(areaIndex)];

        // Call the callback function and pass the necessary values
        callback(this_area, areaIndex);
    }
}

function insulatedMultispanWarning({ job, engValid, this_area, areaIndex }) {
    let is_flat = false;
    if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) is_flat = true;
    // let AreaMaxResults = job.QuoteParameters?.ENGINEERING?.EngineeringResults?.AreaMaxResults?.[areaIndex];
    if (
        is_flat &&
        this_area?.ROOF_SHEETING?.RoofSheetData?.["InsulatedOverspan"] &&
        this_area?.ROOF_SHEETING?.RoofSheetData?.PressureTableMaxSpanSingle &&
        !engValid
    ) {
        let sheetName, length, maxSpan, roofsheet;
        maxSpan = this_area?.ROOF_SHEETING?.RoofSheetData?.PressureTableMaxSpanDouble;
        sheetName = this_area?.ROOF_SHEETING?.RoofSubType;
        length = this_area.SHAPE.Depth;
        return insulatedSpanWarning({ job, sheetName, length, areaIndex, this_area, roofsheet, maxSpan });
    }
}

function maxPostHeightWarning({
    job,
    engValid,
    this_area,
    areaIndex,
    config,
    app,
    user,
    confirmEngineeringAction,
    overrideEngineeringAction,
}) {
    // Check max height for posts
    const isFlanged =
        job?.AreaSpecifications[areaIndex].BEAMS_AND_POSTS.CornerPostsFullHeight === 2 ||
        job?.AreaSpecifications[areaIndex].BEAMS_AND_POSTS.IntermediatePostsFullHeight === 2;

    let product = config.post_types[job?.AreaSpecifications[areaIndex]?.BEAMS_AND_POSTS?.PostType]?.["Product Code"];

    if (!product) return;

    // Check if the post if flanged.
    if (isFlanged) {
        product += "F";
    }

    // Initialize findPostProduct as an empty array
    let findPostProduct = [];

    if (app && app.pricefile && Array.isArray(app.pricefile.data)) {
        findPostProduct = app.pricefile.data.filter((e) => product === e.ProductIndex);
    }

    // get POA
    let currentPOA = "SL_" + job?.POA;

    let postChanges = job?.AreaSpecifications[areaIndex]?.POSTMODIFICATIONS;
    let footingChanges = job?.AreaSpecifications[areaIndex]?.Footings;
    let currentPosts = {};

    // extra cut as 500 for post all in concrete no post changes.
    let extraCut = 0;

    if (
        (footingChanges?.length === 0 || footingChanges === undefined) &&
        (postChanges?.length === 0 || postChanges === undefined)
    ) {
        extraCut = 0;
    } else {
        // Loop through footings and posts

        if (footingChanges)
            for (var foot of footingChanges) {
                const ref = foot?.Ref2 ? foot.Ref2 : foot.Ref;
                currentPosts[ref] = { Ref: ref, footing: foot.Kind };
            }

        if (postChanges)
            for (var post of postChanges) {
                const ref = post?.Ref2 ? post?.Ref2 : post?.Ref;
                if (currentPosts[ref]) {
                    currentPosts[ref]["post"] =
                        post.Section === ""
                            ? job?.AreaSpecifications[areaIndex].BEAMS_AND_POSTS.PostType
                            : post.Section;
                    currentPosts[ref]["Length"] = post?.Length;
                } else {
                    currentPosts[ref] = {
                        Ref: ref,
                        post:
                            post.Section === ""
                                ? job?.AreaSpecifications[areaIndex].BEAMS_AND_POSTS.PostType
                                : post.Section,
                        Length: post.Length,
                    };
                }
            }
    }


    // Check default posts
    if (findPostProduct[0]?.PromptTextCodes) {
        const pos = getPos({ currentPOA, findPostProduct });

        if (pos > -1) {
            console.log("findPostProduct", findPostProduct, findPostProduct[0]?.PromptTextCodes);

            let productName;
            for (var post_type of Object.values(config.post_types)) {
                console.log(post_type);
                console.log(findPostProduct[0]?.ProductIndex);
                if (post_type["Product Code"] === findPostProduct[0]?.ProductIndex) {
                    productName = job?.AreaSpecifications[areaIndex].BEAMS_AND_POSTS.PostType;
                    break;
                }
            }

            const maxPostHeight = getMaxPostHeight({ findPostProduct, pos, currentPOA, extraCut });

            let warning = postHeightWarning({
                job,
                pos,
                maxPostHeight,
                confirmEngineeringAction,
                user,
                overrideEngineeringAction,
                postName: productName,
                engValid,
            });

            if (warning) {
                return warning;
            }
        }
    }

    // Check Changed Posts
    if (window.LYSAGHT)
        for (var _post of Object.keys(currentPosts)) {
            console.log(_post);
            if (currentPosts[_post]?.post) {
                // Find changed post
                let productCode = config.post_types[currentPosts[_post]?.post]["Product Code"];

                // Check if the post if flanged.
                if (isFlanged) {
                    productCode += "F";
                }

                let findChangedPostProduct = app.pricefile.data.filter((e) => productCode === e.ProductIndex);

                let productName = currentPosts[_post]?.post;

                console.log(findChangedPostProduct);
                console.log(config.post_types[currentPosts[_post]?.post]);

                // Check if allowed notched and notched selected
                if (!config.post_types[currentPosts[_post]?.post].allow_notched && isFlanged) {
                    let warning = postNotchedWarning({
                        postName: productName,
                        areaIndex,
                        this_area,
                    });

                    if (warning) {
                        return warning;
                    }
                }

                // Check if footing change allowed to be flanged ("Bolt to slab") with current post
                if (
                    currentPosts[_post]?.footing &&
                    currentPosts[_post]?.footing !== "Concrete In" &&
                    !config.post_types[currentPosts[_post]?.post].allow_notched &&
                    !config.post_types[currentPosts[_post]?.post]?.Base_Plate_Code_Flat_Internal
                ) {
                    let warning = postFootingWarning({
                        areaIndex,
                        this_area,
                        footingType: currentPosts[_post]?.footing,
                        postName: productName,
                        post: _post,
                    });

                    if (warning) {
                        return warning;
                    }
                }

                // Only check if there are promptcodes
                if (findChangedPostProduct[0]?.PromptTextCodes) {
                    const pos = getPos({ currentPOA, findPostProduct: findChangedPostProduct });

                    if (pos > -1) {
                        console.log(
                            "findChangedPostProduct",
                            findChangedPostProduct,
                            findChangedPostProduct[0]?.PromptTextCodes
                        );

                        if (currentPosts[_post]?.footing) {
                            if (currentPosts[_post].footing !== "Concrete In") {
                                extraCut = 0;
                            } else extraCut = 500; // Change to default footing
                        }

                        const maxPostHeight = getMaxPostHeight({
                            findPostProduct: findChangedPostProduct,
                            pos,
                            currentPOA,
                            extraCut,
                        });

                        let warning = postHeightWarning({
                            job,
                            pos,
                            maxPostHeight,
                            confirmEngineeringAction,
                            user,
                            overrideEngineeringAction,
                            postName: productName,
                            height: currentPosts[_post].Length,
                            engValid,
                        });

                        if (warning) {
                            return warning;
                        }
                    }
                }
            } else {
                // Only a footing change.
                // Check if footing change allowed to be flanged ("Bolt to slab") with default post
                if (
                    currentPosts[_post]?.footing &&
                    currentPosts[_post]?.footing !== "Concrete In" &&
                    !config.post_types[currentPosts[_post]?.post]?.allow_notched &&
                    !config.post_types[job?.AreaSpecifications[areaIndex]?.BEAMS_AND_POSTS?.PostType]
                        ?.Base_Plate_Code_Flat_Internal
                ) {
                    let warning = postFootingWarning({
                        areaIndex,
                        this_area,
                        footingType: currentPosts[_post]?.footing,
                        postName: job?.AreaSpecifications[areaIndex]?.BEAMS_AND_POSTS?.PostType,
                        post: _post,
                    });

                    if (warning) {
                        return warning;
                    }
                }
            }
        }
}

// When set, the software will ignore these warnings in the future for that AreaIndex.
function setIgnoreAreaWarning({ areaIndex, dispatch, warning, job, config, app }) {
    let new_job = COMMON.deepCopy(job);

    if (!new_job.AreaSpecifications[areaIndex].IGNORED_WARNINGS) {
        new_job.AreaSpecifications[areaIndex].IGNORED_WARNINGS = [];
    }

    new_job.AreaSpecifications[areaIndex].IGNORED_WARNINGS.push(warning);

    // forced compliance/ mass settings, updates
    new_job = validateFullJob(config, new_job, -1, app);

    dispatch({
        type: "NEW_JOB",
        parameter: new_job,
    });
}

// Remove ignored warning from AreaSpecifications[areaIndex].IGNORED_WARNINGS
function removeIgnoreAreaWarning({ areaIndex, dispatch, warning, job, config, app }) {
    let new_job = COMMON.deepCopy(job);

    if (new_job.AreaSpecifications[areaIndex].IGNORED_WARNINGS) {
        new_job.AreaSpecifications[areaIndex].IGNORED_WARNINGS = new_job.AreaSpecifications[
            areaIndex
        ].IGNORED_WARNINGS.filter((ignoredWarning) => ignoredWarning.title !== warning.title);

        // forced compliance/ mass settings, updates
        new_job = validateFullJob(config, new_job, -1, app);

        dispatch({
            type: "NEW_JOB",
            parameter: new_job,
        });
    }
}

function checkIgnoreWarning({ job, areaIndex, warning }) {
    if (
        job?.AreaSpecifications[areaIndex].IGNORED_WARNINGS &&
        job.AreaSpecifications[areaIndex].IGNORED_WARNINGS.some(
            (ignoredWarning) => ignoredWarning.title === warning.title
        )
    ) {
        return warning;
    }
    return null;
}

function overhangPVCdownpipe({ job, areaIndex, config, app, dispatch }) {
    const shape = job?.AreaSpecifications[areaIndex]?.SHAPE;

    const standardOverhangs = {
        OH_Back: 0,
        OH_Back_Sheet: 0,
        OH_Front: 0,
        OH_Front_Sheet: 0,
        OH_Left: 0,
        OH_Left_Sheet: 0,
        OH_Right: 0,
        OH_Right_Sheet: 0,
    };

    let sum = 0;
    for (const key in standardOverhangs) {
        if (shape && shape.hasOwnProperty(key)) {
            sum += shape[key];
        }
    }

    const recommended_downpipe = window.LYSAGHT ? "Lysaght 90mm Round PVC Downpipe" : "90mm Round PVC Downpipe";
    const warning = {
        title: "Roofsheets with Overhang should have PVC downpipes",
        recommendedValue: recommended_downpipe,
    };

    let ignoreWarning = checkIgnoreWarning({ job, areaIndex, warning });

    // Overhangs were changed and not PVC selected
    if (sum !== 0 && !job?.AreaSpecifications[areaIndex]?.GUTTERS_AND_DOWNPIPES?.DownpipeType.includes("PVC")) {
        // Check if warning is already ignored
        if (ignoreWarning) return;
        return {
            error: true,
            title: "Roofsheets with Overhang should have PVC downpipes",
            message: [<>'{recommended_downpipe}' is recommended with Sheet overhang.</>],
            primaryActionText: `Set to '${recommended_downpipe}'`,
            primaryAction: () => {
                let new_job = COMMON.deepCopy(job);
                new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.DownpipeType = recommended_downpipe;
                //forced compliance/ mass settings, updates
                new_job = validateFullJob(config, new_job, -1, app);
                dispatch({
                    type: "NEW_JOB",
                    parameter: new_job,
                });
            },
            secondaryActionText: "Add Ignore",
            secondaryAction: setIgnoreAreaWarning({ areaIndex, dispatch, warning, job, config, app }),
        };
    } else if (ignoreWarning) {
        // Warnings can be removed
        // UNCOMMENT FOR REMOVING INGNORED WARNINGS - Future development
        // return {
        //     error: true,
        //     title: "Downpipe Warning can be removed",
        //     message: `You can remove your ignored warning: '${ignoreWarning.title}'. Future warnings will be shown for this issue.`,
        //     secondaryActionText: "Keep Ignoring",
        //     primaryAction: () => removeIgnoreAreaWarning({ areaIndex, dispatch, warning, job, config, app }),
        // };
    }
}

/// Dialog POPUPS

// These are warnings that are checked at the end of the system.
// Can be bypassed with engineering override, Can continue.
export function jobWarningPopups(props) {
    let warnings;
    allAreaSpecifications(props.job, (this_area, areaIndex) => {
        // Add warnings here...
        // warnings = brickworkBondorHeightCondition(props) ? bondorBrickworkWarning({ ...props }) : warnings;
    });

    return warnings; // Return the error, note this will work top down of all warnings
}

// These are Errors that are checked at the end of the system.
// Can be bypassed with engineering override, but default is to block from continuing.
export function jobReadyStateErrorPopups(props) {
    let errors;
    let template_primaryAction = ({ primaryActionString, props, this_area, areaIndex }) => {
        let new_job = COMMON.deepCopy(props.job);

        const primaryConditions = createConditionFunction(primaryActionString);

        primaryConditions({ ...props, this_area, areaIndex, new_job }); // Updates new_job

        //forced compliance/ mass settings, updates
        new_job = validateFullJob(props.config, new_job, -1, props.app);
        props.dispatch({
            type: "NEW_JOB",
            parameter: new_job,
        });
    };
    let error_template = {
        error: true,
        title: "",
        message: [<></>],
        primaryActionText: "Set to",
        secondaryActionText: "Cancel",
        tertiaryActionText: props.user.Role >= 91 ? "Authorise Override?" : "",
        tertiaryAction: props.user.Role >= 91 ? props.overrideEngineeringAction : {},
        primaryAction: null,
    };

    allAreaSpecifications(props.job, (this_area, areaIndex) => {
        // Add Errors here...
        errors = maxPostHeightWarning({ ...props, this_area, areaIndex }) || errors;
        errors = insulatedMultispanWarning({ ...props, this_area, areaIndex }) || errors;
        // errors = brickworkBondorHeightCondition(props) ? bondorBrickworkWarning({ ...props }) : errors;

        const allWarnings = props?.config?.all_warnings;
        if (allWarnings?.jobStateError) {
            const warning = allWarnings?.jobStateError;

            for (const type in warning) {
                if (warning.hasOwnProperty(type) && type !== "info") {
                    const conditionStrings = warning[type]?.conditions;
                    const condition = createConditionFunction(conditionStrings);
                    const message = warning[type]?.message;
                    const title = warning[type]?.title;
                    const primaryActionString = warning[type]?.primaryAction;
                    const primaryActionText = warning[type]?.primaryText;

                    if (condition({ ...props, this_area, areaIndex })) {
                        error_template["title"] = title;
                        error_template["message"] = (
                            <>{interpolate(message, { props: { ...props, this_area, areaIndex } })}</>
                        );
                        error_template["primaryActionText"] = interpolate(primaryActionText, {
                            props: { ...props, this_area, areaIndex },
                        });
                        error_template["primaryAction"] = () =>
                            template_primaryAction({
                                props,
                                primaryActionString,
                                this_area,
                                areaIndex,
                            });
                        errors = error_template;
                    }
                }
            }
        }
    });

    return errors; // Return the error, note this will work top down of all Errors
}

// These are Errors that are checked with any change in the system.
// Can not be bypassed with engineering override.
export function jobStateErrorPopups(props) {
    let errors;

    allAreaSpecifications(props.job, (this_area, areaIndex) => {
        // Add Errors here...
        errors = overhangPVCdownpipe({ ...props, this_area, areaIndex }) || errors;
    });

    return errors; // Return the error, note this will work top down of all Errors
}

/// Message POPUPS
// These are checked before job validation
export function jobStateMessagePopups(props) {
    allAreaSpecifications(props.job, (this_area, areaIndex) => {
        // roofPitchChangedSkylight({ ...props, this_area, areaIndex });
        // Add Warnings here...

        const allWarnings = props?.config?.all_warnings;
        if (allWarnings?.jobStateMessagePopups) {
            const warning = allWarnings?.jobStateMessagePopups;

            for (const type in warning) {
                if (warning.hasOwnProperty(type) && type !== "info") {
                    const conditionStrings = warning[type]?.conditions;
                    const condition = createConditionFunction(conditionStrings);
                    const message = warning[type]?.message;

                    if (condition({ ...props, this_area, areaIndex })) {
                        props.dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: message,
                        });
                    }
                }
            }
        }
    });
}

jobWarningPopups.propTypes = {
    job: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
};

jobStateMessagePopups.propTypes = {
    job: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
};

jobReadyStateErrorPopups.propTypes = {
    job: PropTypes.object.isRequired,
    engValid: PropTypes.bool.isRequired,
    dispatch: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    confirmEngineeringAction: PropTypes.func.isRequired,
    overrideEngineeringAction: PropTypes.func.isRequired,
};

jobStateErrorPopups.propTypes = {
    job: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired,
};
